<template>
  <div class="detail">
    <div class="title">{{$t('transferDetail.details')}}</div>
    <div class="section">
      <div class="row">
        <div class="col">{{$t('transferDetail.hash')}}</div>
        <div class="col">{{hash}}<img @click="onHashCopy" src="../../assets/icons/copy.png" ></div>
      </div>
      <div class="row">
        <div class="col">{{$t('transferDetail.status')}}</div>
        <div class="col">
          <span v-if="status == 'confirmed'"><span class="pot confirmed"></span>{{$t('blockDetail.confirmed')}}</span>
          <span v-else><span class="pot"></span>{{$t('blockDetail.pending')}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">{{$t('transferDetail.block')}}</div>
        <div class="col"><router-link :to="'/blockDetails?block=' + block">{{block}}</router-link></div>
      </div>
      <div class="row">
        <div class="col">{{$t('transferDetail.time')}}</div>
        <div class="col">{{time}}</div>
      </div>
      <dna-spin v-if="isLoading"></dna-spin>
    </div>
    <div class="title title-2">{{$t('transferDetail.dnaTransfer')}}</div>
    <div class="section">
      <div class="row" v-if="from">
        <div class="col">{{$t('transferDetail.sender')}}</div>
        <div class="col">{{from}}</div>
      </div>
      <div class="row" v-if="to">
        <div class="col">{{$t('transferDetail.receiver')}}</div>
        <div class="col">{{to}}</div>
      </div>
      <div class="row" v-if="amount">
        <div class="col">{{$t('transferDetail.amount')}}</div>
        <div class="col">{{amount}} DNA</div>
      </div>
      <div class="row" v-if="token">
        <div class="col">{{$t('transferDetail.token')}}</div>
        <div class="col">{{token}}</div>
      </div>
      <div class="call-row">
        <div class="col">{{$t('transferDetail.call')}}</div>
        <div class="col">
          <div class="small-row">
            <div>{{$t('transferDetail.method')}}</div>
            <div>{{method}}</div>
          </div>
          <div class="small-row">
            <div>{{$t('transferDetail.arguments')}}</div>
            <div>{{args}}</div>
          </div>
        </div>
      </div>
      <dna-spin v-if="isLoading"></dna-spin>
    </div>
  </div>
</template>

<script>
export default {
  props: ['hash', 'status', 'block', 'time', 'from', 'to', 'amount', 'token', 'isLoading', 'method', 'args'],
  methods: {
    onHashCopy () {
      let that = this
      that.$copyText(that.hash).then((e) => {
        that.$Message.success({
          background: true,
          content: that.$t('global.copySuccess')
        })
      }, (e) => {
        that.$Message.error({
          background: true,
          content: that.$t('global.copyFail')
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./TransferDetail.less');
</style>